// refreshSlice.ts
import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    projects: false
};
export const refreshSlice = createSlice({
    name: 'refresh',
    initialState,
    reducers: {
        refreshProjects: (state) => {
            state.projects = !state.projects;
        }
    }
});
export const { refreshProjects } = refreshSlice.actions;
export default refreshSlice;
